import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import VueAxios from 'vue-axios';

axios.defaults.baseURL = '';

Vue.use(VueAxios, axios)

Vue.config.productionTip = false;
Vue.config.devtools = true; // Turn off after deployment

new Vue({
  render: h => h(App),
}).$mount('#kingpin-selector')
